import React from 'react';
import './TopHeader.scss';
import classNames from 'classnames';
import TopHeaderBusiness from './TopHeaderBusiness';

function TopHeader({
  showChangeLanguageButton,
  linkLangMap,
  langCode,
  hasScrolled,
  menuTopHeaderBusiness,
}) {
  return (
    <div
      className={classNames('top-header', {
        'reduce-height': hasScrolled,
      })}
      data-submodule-name='top-header'
    >
      <nav
        className={classNames('top-header-content wrapper', {
          'reduce-opacity': hasScrolled,
        })}
      >
        <TopHeaderBusiness
          showChangeLanguageButton={showChangeLanguageButton}
          linkLangMap={linkLangMap}
          langCode={langCode}
          menuTopHeaderBusiness={menuTopHeaderBusiness}
        />
      </nav>
    </div>
  );
}

export default TopHeader;
